import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { Accordion } from '../components/ui/Accordion';
import { faqGroups } from '../data/faqs';
import { IMAGES } from '../data/images';
import { BOOKING_URL, SITE } from '../data/site';
export function Faq() {
  return <>
      <Seo title="FAQ — CCW & Firearms Training" description="Answers about Las Vegas CCW classes, Nevada CCW renewal, gun rentals, what to bring and where classes are held." data-id="element-804" data-mp="370xj034qmuqg" />
      <PageHero title="Frequently Asked Questions" sub="Straight answers. If yours isn’t here, call — a real instructor picks up." image={IMAGES.classroom} crumbs={[{
      label: 'FAQ'
    }]} data-id="element-805" data-mp="3gra1lpszsdty" />
      <section className="gutter section grid gap-14 bg-white lg:grid-cols-12" data-id="element-806" data-mp="3pshwrz07oyjt">
        <div className="space-y-16 lg:col-span-8 2xl:col-span-9" data-id="element-807" data-mp="3lrobzei2fzv5">
          {faqGroups.map((g, gi) => <section key={g.title} aria-labelledby={`faq-group-${gi}`} data-id="element-808" data-mp="264qbwtw9v54x" data-mpi={gi}>
              <h2 id={`faq-group-${gi}`} className="t-h3 text-navy" data-id="element-809" data-mp="266t85vo0pui3">{g.title}</h2>
              <span className="red-rule mb-6 mt-3" aria-hidden="true" data-id="element-810" data-mp="2a6bsap80m1jv" />
              <Accordion items={g.items} data-id="element-811" data-mp="2f43nbs3yi3sa" />
            </section>)}
          <p className="text-xs text-steel" data-id="element-812" data-mp="2k4rag2p2e0h8">Not legal advice. Information is educational and subject to change.</p>
        </div>
        <aside className="lg:col-span-4 2xl:col-span-3" data-id="element-813" data-mp="2p2je1tz2nb19">
          <div className="rounded-[4px] bg-navy p-7 lg:sticky lg:top-[calc(var(--header-h)+1.5rem)]" data-id="element-814" data-mp="2t4o3egihlli3">
            <h2 className="t-h3 text-white" data-id="element-815" data-mp="2xvwfjkb7bkyy">Still have questions?</h2>
            <p className="mt-2 text-chrome-300" data-id="element-816" data-mp="2xxpj2qqipp2q">We train 7 days a week and answer the phone daily.</p>
            <div className="mt-6 grid gap-3" data-id="element-817" data-mp="32wk31w081jof">
              <ButtonLink href={SITE.phoneHref} variant="outline-light" data-id="element-818" data-mp="37ulnoldapr20">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-819" data-mp="3csne5rd1wsni" /> {SITE.phoneDisplay}
              </ButtonLink>
              <ButtonLink href={BOOKING_URL} data-id="element-820" data-mp="2n4854wansmza">Book a Class</ButtonLink>
            </div>
          </div>
        </aside>
      </section>
    </>;
}